import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

import TagList from './TagList'

import Element from '../services/Element.js';
import Player from '../services/player.js';
import Train from '../services/train.js';

import '../../css/ElementMenu.css';

class ElementMenu extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      active: props.active,
      x: props.x,
      y: props.y,
      scrollX: props.scrollX,
      element: props.element,
      picture: 'img/microphone_icon.svg',
      tags: [],
      location: {},
      startYear: ''
    }

    this.hide = props.hide;
    this.width = 350;
    this.height = 260;
    this.previousElement = undefined;

    this.headerHeight = 50;
    this.playerHeight = 60;
    this.mapHeaderHeight = 30;

    this.iconSize = 24;

    this.fetchData(props.element);

  }

  componentWillReceiveProps(newProps) {
    
    this.hide = newProps.hide;

    if (!newProps.element) {
      this.setState({
        active: newProps.active
      });
      return;
    }

    this.setState({
      active: newProps.active,
      x: newProps.x,
      y: newProps.y,
      scrollX: newProps.scrollX,
      element: newProps.element
    });

    this.previousElement = this.state.element;

    let elementData = newProps.elementData || {};

    if (newProps.element && this.previousElement !== newProps.element) {
      this.setState({
        picture: elementData.img || 'img/microphone_icon.svg',
        tags: elementData.tags || [],
        location: elementData.location || {country_code: elementData.country_code},
        gender: elementData.gender || 'unknown',
        startYear: elementData.start_year || ''
      });
      this.fetchData(newProps.element);
    }

  }

  fetchData(element) {

    if (!element || element.trim().length === 0)
      return;

    Train.fetchArtistProfile({type: 'artist', element: element})
    .then((info) => {
      if (element === this.state.element) {
        let state = this.state;
        this.setState({tags: info.tags || state.tags, startYear: info.start_year || state.startYear, location: info.location || state.location, picture: info.img || state.picture, gender: info.gender || state.gender});
      }
    });

  }

  goToPage(element, evt) {
    evt.stopPropagation();
    evt.preventDefault();
    this.hide();
    this.props.history.push(Element.url('artist', {artist: element}));
  }

  goToMap(element, evt) {
    evt.stopPropagation();
    evt.preventDefault();
    this.hide();
    this.props.history.push(Element.mapUrl('artist', {artist: element}));
  }

  playElement(element, evt) {
    evt.stopPropagation();
    evt.preventDefault();
    this.hide();
    Player.searchTracks({type: 'artist', terms: [{artist: element}] })
  }

  getWidth() {
    return window.innerWidth;
  }

  getHeight() {
    return window.innerHeight - this.playerHeight - this.headerHeight;
  }

  getPosition(x, y) {
    let pos = {x,  y};

    if (pos.x + this.width >= this.getWidth()) {
      pos.x = Math.max(this.headerHeight + 10, this.getWidth() - this.width - 10);
    }

    if (pos.y + this.height >= this.getHeight()) {
      pos.y = Math.max(this.headerHeight + 10, this.getHeight() - this.height - 10);
    }

    if (this.state.scrollX) {
      pos.x += this.state.scrollX;
    }

    return pos;
  }

  render() {

    let position = this.getPosition(this.state.x, this.state.y);

    let pictureStyle = {'backgroundImage': `url(${this.state.picture})`};

    let menuStyle = {'top': position.y, 'left': position.x};

    if (!this.state.active) 
      return null;

    let countryCode = this.state.location.country_code;
    let countryImg = countryCode ? 'simple_flags/4x3/' + countryCode + '.svg' : '';

    let gender = this.state.gender;
    let genderImg = gender ? 'img/gender_' + this.state.gender + '_icon.svg' : '';

    let startYear = this.state.startYear;

    let element = this.state.element;

    return (
      
      <div style={menuStyle} className="elementMenu" onClick={this.hide.bind(this)}>
        <div style={pictureStyle} className="picture">
        </div>

        <div className="info">
          <label>{element}</label> 
          { gender  && (<img alt={"gender symbol for " + gender} width='16px' height='16px' src={genderImg}></img>) }
          { countryCode  && (<img alt={"country flag for " + countryCode} width='24px' height='16px' style={{'marginLeft':'5px'}} src={countryImg}></img>) }
          <br/>
          { startYear && (<span>{startYear}</span>) }
        </div>
  
        <TagList expanded="true" tags={this.state.tags}/>
          
        <div className="options">

          <i title="Go to page" onClick={this.goToPage.bind(this, element)} className="fontastic icon-info clickable"></i>
          <i title="Go to similarity map" onClick={this.goToMap.bind(this, element)} className="fontastic icon-map clickable"></i>
          <i title="Play" onClick={this.playElement.bind(this, element)} className="fontastic icon-play clickable"></i>

        </div>

      </div>
      
    );

  }

}

export default withRouter(ElementMenu);



// WEBPACK FOOTER //
// ./src/js/components/ElementMenu.jsx